export default "__VITE_ASSET__BdN$GFkM__"